import React from "react";
import {
  Box,
  Text,
  Stack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useState } from "react";
import { signUp } from "../services/signUp";
import { GoBackButton } from "./GoBackButton";
import { USER_TYPES } from "../../../utils/userRole";

// Nigerian local (08012345678) or international (+2348012345678) format —
// mirrors the backend's createUser.validation.js phoneNumber matcher.
const PHONE_PATTERN = /^(0\d{10}|\+234\d{10})$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SignUp = ({ setSignUpp }) => {
  // const dispatch = useDispatch()

  const [registerType, setRegisterType] = useState(USER_TYPES.ESTATE_MEMBER);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const pageColor = "primary.500";

  const clearError = (field) =>
    setErrors((prev) => (prev[field] ? { ...prev, [field]: undefined } : prev));

  const validate = () => {
    const nextErrors = {};
    if (!name.trim()) nextErrors.name = "Name is required";
    if (!email.trim()) nextErrors.email = "Email is required";
    else if (!EMAIL_PATTERN.test(email.trim()))
      nextErrors.email = "Enter a valid email address";
    if (!phone.trim()) nextErrors.phone = "Phone number is required";
    else if (!PHONE_PATTERN.test(phone.trim()))
      nextErrors.phone =
        "Enter a valid Nigerian phone number, e.g. 08012345678 or +2348012345678";
    if (!password) nextErrors.password = "Password is required";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSignUp = async () => {
    if (!validate()) return;

    const payload = {
      email,
      name,
      password,
      phoneNumber: phone,
      userType: registerType,
    };

    setLoading(true);
    await signUp(payload, setLoading, setSignUpp);
  };

  return (
    <Stack
      height="100%"
      overflowY={"auto"}
      width="100%"
      px={["8px", "12px", "20px"]}
      spacing="12px"
    >
      <GoBackButton onClick={() => setSignUpp("signin")} />
      <Text
        color={"black"}
        fontSize={["30px", "34px", "38px"]}
        fontWeight={"semibold"}
        lineHeight="1.1"
      >
        Sign up to Ovend
      </Text>
      <Text
        fontSize={["14px", "16px", "17px"]}
        fontWeight={500}
        color="gray.600"
      >
        Get started, pay your bills, manage utilities, track expenses, and take
        full control of your estate.
      </Text>
      <Tabs
        index={registerType === USER_TYPES.ESTATE_MEMBER ? 0 : 1}
        onChange={(index) =>
          setRegisterType(
            index === 0 ? USER_TYPES.ESTATE_MEMBER : USER_TYPES.VTU_USER,
          )
        }
        isFitted
        variant="unstyled"
      >
        <TabList
          mb="18px"
          gap={"1em"}
          borderWidth="1px"
          borderColor={"gray.200"}
          borderRadius="default"
          px="18px"
          py="9px"
          bg="white"
        >
          <Tab
            borderRadius="default"
            bg="gray.50"
            _selected={{ bg: pageColor, color: "#FFFFFF" }}
            _hover={{ bg: "primary.700", color: "#FFFFFF" }}
            color={pageColor}
            fontWeight={500}
            fontSize={["12px", "13px", "14px"]}
            px={["10px", "12px", "14px"]}
            py="10px"
          >
            Register as Estate Member
          </Tab>
          <Tab
            borderRadius="default"
            bg="gray.50"
            _selected={{ bg: pageColor, color: "#FFFFFF" }}
            _hover={{ bg: "primary.700", color: "#FFFFFF" }}
            color={pageColor}
            fontWeight={500}
            fontSize={["12px", "13px", "14px"]}
            px={["10px", "12px", "14px"]}
            py="10px"
          >
            Register as General User
          </Tab>
        </TabList>

        <TabPanels p={0}>
          <TabPanel p={0}>
            <Stack spacing={0}>
              <FormControl isInvalid={!!errors.name} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="estate-name"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Name
                </FormLabel>
                <Input
                  id="estate-name"
                  type="text"
                  bg="#F9FEFF"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    clearError("name");
                  }}
                />
                <FormErrorMessage>{errors.name}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.phone} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="estate-phone"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Phone Number
                </FormLabel>
                <Input
                  id="estate-phone"
                  type="tel"
                  bg="#F9FEFF"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    clearError("phone");
                  }}
                />
                <FormErrorMessage>{errors.phone}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.email} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="estate-email"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Email
                </FormLabel>
                <Input
                  id="estate-email"
                  type="email"
                  bg="#F9FEFF"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    clearError("email");
                  }}
                />
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.password} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="estate-password"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Password
                </FormLabel>
                <Input
                  id="estate-password"
                  type="password"
                  bg="#F9FEFF"
                  mb="15px"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    clearError("password");
                  }}
                />
                <FormErrorMessage>{errors.password}</FormErrorMessage>
              </FormControl>
            </Stack>
          </TabPanel>

          <TabPanel p={0}>
            <Stack spacing={0}>
              <FormControl isInvalid={!!errors.name} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="general-name"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Name
                </FormLabel>
                <Input
                  id="general-name"
                  type="text"
                  bg="#F9FEFF"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    clearError("name");
                  }}
                />
                <FormErrorMessage>{errors.name}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.phone} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="general-phone"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Phone Number
                </FormLabel>
                <Input
                  id="general-phone"
                  type="tel"
                  bg="#F9FEFF"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    clearError("phone");
                  }}
                />
                <FormErrorMessage>{errors.phone}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.email} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="general-email"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Email
                </FormLabel>
                <Input
                  id="general-email"
                  type="email"
                  bg="#F9FEFF"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    clearError("email");
                  }}
                />
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.password} cursor={"pointer"} borderColor="#CFE5E2">
                <FormLabel
                  htmlFor="general-password"
                  color={"#4D4A4A"}
                  fontSize="18px"
                  pt={"17px"}
                >
                  Password
                </FormLabel>
                <Input
                  id="general-password"
                  type="password"
                  bg="#F9FEFF"
                  mb="15px"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    clearError("password");
                  }}
                />
                <FormErrorMessage>{errors.password}</FormErrorMessage>
              </FormControl>
            </Stack>
          </TabPanel>
        </TabPanels>
      </Tabs>

      <Box>
        <Button
          size={"lg"}
          color="#FFFFFF"
          w="100%"
          fontWeight={600}
          fontSize={"16px"}
          isLoading={loading}
          onClick={handleSignUp}
        >
          Sign Up
        </Button>
      </Box>
      <Text
        textAlign={"center"}
        fontSize="18px"
        color="#000000"
        fontWeight={400}
      >
        Already have an account?{" "}
        <Text
          as="span"
          color={pageColor}
          onClick={() => setSignUpp("signin")}
          cursor="pointer"
        >
          Sign In.
        </Text>
      </Text>
    </Stack>
  );
};
